import { h, JSX } from "@stencil/core";
import { isString } from "@phn/utility/helper";

export default function Icon({
  isLoading,
  icon,
}: {
  isLoading: boolean;
  icon: string;
}): JSX.Element | null {
  if (isLoading) {
    return (
      <div class="icon-container">
        <phn-p-spinner color="inherit" size="inherit" />
      </div>
    );
  }

  if (isString(icon)) {
    return (
      <div class="icon-container skeleton-item">
        <phn-p-icon color="inherit" size="inherit" source={icon} />
        <slot name="icon-modifier" />
      </div>
    );
  }

  return null;
}
